export default {
  // apiUrl: 'http://localhost:9090/',
  // resourceUrl: 'http://localhost:9191/',
  apiUrl: 'https://home.doyle.wang:9090/', // 后端
  fileUrl: 'https://home.doyle.wang:8989/', // 文件
  resourceUrl: 'https://home.doyle.wang:9191/', // 资源

  url_flame: 'https://home.doyle.wang:8109/', // flame导航
  url_bark: 'https://home.doyle.wang:8105/6XiHTL2Y6sXcAuhN2sfxdL/', // bark消息提醒

  url_ZenTao: 'http://home.doyle.wang:8101/', // 禅道
  url_GitLab: 'http://home.doyle.wang:8102/', // GitLab
  url_YApi: 'http://home.doyle.wang:8103/', // YApi

  // 官网
  captcha: 'valid/captcha', // 验证码
  userLogin: 'user/login', // 用户登录
  userRegister: 'user/register', // 用户注册

  createObjectID: 'util/createID', // 创建ID

  movieList: 'movie/movieList', // 电影列表
  movieDetail: 'movie/movieDetail', // 电影详情

  tvseriesList: 'tvseries/tvseriesList', // 电视剧列表
  tvseriesDetail: 'tvseries/tvseriesDetail', // 电视剧详情

  comicList: 'comic/comicList', // 动漫列表
  comicDetail: 'comic/comicDetail', // 动漫详情

  movieDepartmentList: 'department/movieList', // 系列电影列表
  movieDepartmentDetail: 'department/movieDetail', // 系列电影详情
  tvseriesDepartmentList: 'department/tvseriesList', // 系列电视剧列表
  tvseriesDepartmentDetail: 'department/tvseriesDetail', // 系列电视剧详情
  comicDepartmentList: 'department/comicList', // 系列动漫列表
  comicDepartmentDetail: 'department/comicDetail', // 系列动漫详情

  blogList: 'blog/blogList', // blog列表
  blogDetail: 'blog/blogDetail', // blog详情
  addBlog: 'blog/addBlog', // 新建blog
  delBlog: 'blog/delBlog', // 删除blog
  updateBlog: 'blog/updateBlog', // 修改blog
  removeBlogImage: 'blog/removeImage', // 删除blog图片

  blogTagList: 'blog/blogTagList', // blog标签列表

  addFeedback: 'feedback/addFeedback', // 添加问题反馈

  // 管理员
  backManageLogin: 'backManageLogin', // 管理员登录
  registerCode: 'manage/registerCode', // 获取注册码
  feedbackList: 'manage/feedbackList', // 获取问题反馈列表
  feedbackDetail: 'manage/feedbackDetail', // 获取问题反馈列表
  readFeedback: 'manage/readFeedback', // 获取问题反馈列表
  delFeedback: 'manage/delFeedback', // 获取问题反馈列表

  // localStorage（永久保存）
  userID: 'userID', // 用户ID
  userName: 'userName', // 用户名
  userAuth: 'userAuth', // 用户权限
  userToken: 'userToken', // 用户Token

  // sessionStorage（临时保存）
  resumePermissions: 'resumePermissions', // 简历权限

  // vuex
  storeUserLogin: 'storeUserLogin', // 登录
  storeUserLogout: 'storeUserLogout', // 退出登录
  storeUserAuthType: 'storeUserAuthType', // 用户权限

  // 用户登录状态
  UserAuthType: {
    UserAuthType_Admin: 0,
    UserAuthType_Register: 1,
    UserAuthType_None: 2
  },

  // 地址
  // 电影封面cover
  getMovieCover (id) {
    return this.resourceUrl + 'Movie/' + id + '/cover.jpg'
  },
  // 电影顶部图片title
  getMovieTitle (id) {
    return this.resourceUrl + 'Movie/' + id + '/title.jpg'
  },
  // 人物
  getPersonnelPhoto (id) {
    return this.resourceUrl + 'Personnel/' + id + '.jpg'
  },

  // 电视剧封面cover
  getTVSeriesCover (id) {
    return this.resourceUrl + 'TVSeries/' + id + '/cover.jpg'
  },
  // 电视剧顶部图片title
  getTVSeriesTitle (id) {
    return this.resourceUrl + 'TVSeries/' + id + '/title.jpg'
  },

  // 动漫封面cover
  getComicCover (id) {
    return this.resourceUrl + 'Comic/' + id + '/cover.jpg'
  },
  // 动漫顶部图片title
  getComicTitle (id) {
    return this.resourceUrl + 'Comic/' + id + '/title.jpg'
  },

  // 获取验证码图片
  getValiCodeImage (imageUrl) {
    var url = this.apiUrl + imageUrl
    console.log(url)
    return url
  },

  // 重新获取验证码图片
  reloadValiCodeImage (codeID) {
    var url = this.apiUrl + 'valid/captcha/' + codeID + '.png&reload=' + Math.floor((Math.random() * 1000) + 1)
    console.log(url)
    return url
  },

  // 上传blog图片
  uploadBlogImage () {
    return this.apiUrl + 'blog/uploadImage'
  },

  // 是否登录
  isLogin () {
    if (localStorage.getItem(this.userToken) === null) {
      return false
    } else {
      return true
    }
  },

  // bark推送消息logo
  barkLogo () {
    return this.resourceUrl + 'logo/logo.png'
  }

}



// WEBPACK FOOTER //
// ./src/js/Common.js